var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { ElementRef, Renderer2, Directive } from '@angular/core';
import { Router } from '@angular/router';
var HideFooterDirective = /** @class */ (function () {
    function HideFooterDirective(el, router, renderer) {
        this.el = el;
        this.router = router;
        this.renderer = renderer;
    }
    HideFooterDirective.prototype.ngOnInit = function () {
        var _this = this;
        this.router.events.subscribe(function () {
            if (_this.router.url.indexOf('workflow') > -1)
                _this.renderer.addClass(_this.el.nativeElement, 'd-none');
            else
                _this.renderer.removeClass(_this.el.nativeElement, 'd-none');
        });
    };
    HideFooterDirective = __decorate([
        Directive({
            selector: '[dirHideFooter]'
        }),
        __metadata("design:paramtypes", [ElementRef,
            Router,
            Renderer2])
    ], HideFooterDirective);
    return HideFooterDirective;
}());
export { HideFooterDirective };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaGlkZS1mb290ZXIuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJoaWRlLWZvb3Rlci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7QUFBQSxPQUFPLEVBQUUsVUFBVSxFQUFFLFNBQVMsRUFBRSxTQUFTLEVBQVUsTUFBTSxlQUFlLENBQUM7QUFDekUsT0FBTyxFQUFFLE1BQU0sRUFBRSxNQUFNLGlCQUFpQixDQUFDO0FBS3pDO0lBQ0ksNkJBQTJCLEVBQWMsRUFDcEIsTUFBYyxFQUNkLFFBQW1CO1FBRmIsT0FBRSxHQUFGLEVBQUUsQ0FBWTtRQUNwQixXQUFNLEdBQU4sTUFBTSxDQUFRO1FBQ2QsYUFBUSxHQUFSLFFBQVEsQ0FBVztJQUFJLENBQUM7SUFFdEMsc0NBQVEsR0FBZjtRQUFBLGlCQU9DO1FBTkcsSUFBSSxDQUFDLE1BQU0sQ0FBQyxNQUFNLENBQUMsU0FBUyxDQUFDO1lBQ3pCLElBQUksS0FBSSxDQUFDLE1BQU0sQ0FBQyxHQUFHLENBQUMsT0FBTyxDQUFDLFVBQVUsQ0FBQyxHQUFHLENBQUMsQ0FBQztnQkFDeEMsS0FBSSxDQUFDLFFBQVEsQ0FBQyxRQUFRLENBQUMsS0FBSSxDQUFDLEVBQUUsQ0FBQyxhQUFhLEVBQUUsUUFBUSxDQUFDLENBQUM7O2dCQUV4RCxLQUFJLENBQUMsUUFBUSxDQUFDLFdBQVcsQ0FBQyxLQUFJLENBQUMsRUFBRSxDQUFDLGFBQWEsRUFBRSxRQUFRLENBQUMsQ0FBQztRQUNuRSxDQUFDLENBQUMsQ0FBQztJQUNQLENBQUM7SUFaUSxtQkFBbUI7UUFIL0IsU0FBUyxDQUFDO1lBQ1AsUUFBUSxFQUFFLGlCQUFpQjtTQUM5QixDQUFDO3lDQUVpQyxVQUFVO1lBQ1osTUFBTTtZQUNKLFNBQVM7T0FIL0IsbUJBQW1CLENBYS9CO0lBQUQsMEJBQUM7Q0FBQSxBQWJELElBYUM7U0FiWSxtQkFBbUIifQ==